import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import StaticTable from "../StaticTable/StaticTable";

const Sources = ({ details, loading = false }) => {
  const intl = useIntl();
  const [sourceItems, setSourceItems] = useState([]);

  const getSources = () => {
    try {
      const items = [];
      Object.keys(details?.digital_identity?.source_fields || {}).forEach(
        (key) => {
          if (details?.digital_identity?.source_fields[key]?.length) {
            const copy = details?.digital_identity?.source_fields[key]?.map(
              (item) => ({ ...item, source: key })
            );
            items.push(...copy);
          }
        }
      );
      setSourceItems(items);
    } catch (error) {}
  };
  useEffect(() => {
    getSources();
  }, [details]);
  const columns = [
    {
      header: intl.formatMessage({
        id: "label.sources",
        defaultMessage: "Sources",
      }),
      accessorKey: "source",
    },
    {
      header: intl.formatMessage({
        id: "label.field",
        defaultMessage: "Field",
      }),
      accessorKey: "field",
    },
    {
      header: intl.formatMessage({
        id: "label.value",
        defaultMessage: "Value",
      }),
      accessorKey: "value",
    },
  ];
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 col-lg-12 px-0">
          <div className="custom-border">
            <StaticTable
              columns={columns}
              data={sourceItems}
              defaultErrorMessage={"No Sources Present for this Person"}
              messageId={"id.sources.table.no-records"}
              loading={loading}
              clickableRow={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sources;
